import {action, observable, runInAction} from 'mobx'
import {AdminLoginApi, AdminLoginIndexResponse} from "../../swagger";
import {globalStore} from "../GlobalStore";
import {adminApiWrapper} from "../../common/Api/Admin/adminApiWrapper";
import {createApiConfiguration} from "../../utils/apiFactory";


export class LoginUserStore {
  @observable
  public loginUserInfo = new AdminLoginIndexResponse();

  @observable
  public loading: boolean = false;

  @action
  getLoginUser() {
    // キャッシュがあればキャッシュを返す
    if (this.loginUserInfo && this.loginUserInfo.id) {
      return
    }

    this.loading = true;
    let api = new AdminLoginApi(createApiConfiguration());
    adminApiWrapper(() => {
        return api.index().then((res: AdminLoginIndexResponse) => {
          runInAction(() => {
            this.loginUserInfo = res;
            this.loading = false;
          })
        }).catch(() => {
          runInAction(() => {
            this.loading = false;
          })
        })
      }
      , "getLoginUser"
    );
  }

  @action
  logout() {
    // ログアウトAPIを直接呼び出す
    const fetchApi = createApiConfiguration().fetchApi!;

    fetchApi('/api/admin/logout', {
      method: 'GET',
      credentials: 'include'
    }).then(() => {
      runInAction(() => {
        this.loginUserInfo = new AdminLoginIndexResponse();
      });
      globalStore.routing.history.push("/login");
    }).catch((error) => {
      console.error('Logout error:', error);
      // エラーが発生してもログイン画面にリダイレクト
      runInAction(() => {
        this.loginUserInfo = new AdminLoginIndexResponse();
      });
      globalStore.routing.history.push("/login");
    });
  }
}

export const loginUserStore = new LoginUserStore()


